import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UserWithSocialLink } from '../../index';

import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

interface MeetInterviewerSectionPros {
    title: string;
    contacts: UserWithSocialLink[];
    arrOfEmailsOfImageError: string[];
    showLinkedin: boolean;
}

const displayName = (fullName: string | null, givenName: string, familyName: string): string => {
    let name = fullName;
    if (!name) {
        name = `${givenName ?? ''} ${familyName ?? ''}`;
    }
    return name;
};

const validateLinkedInUrl = (url: string): string | undefined => {
    if (!url || !url.includes('linkedin.com')) {
        return undefined;
    }
    if (!/^https?:\/\//i.test(url)) {
        return `https://${url}`;
    }
    return url;
};

const MeetInterviewerSection: React.FC<MeetInterviewerSectionPros> = ({
    title,
    contacts,
    arrOfEmailsOfImageError = [],
    showLinkedin,
}) => {
    return (
        <>
            <h3 className="heading-2">{title}</h3>
            <div className="interviewerContainer">
                {contacts.map(
                    (contact) =>
                        displayName(contact.fullName, contact.givenName, contact.familyName).trim() && (
                            <div key={contact.email} className="interviewerItem">
                                <div className="interviewerImageContainer relative">
                                    <a
                                        style={{ textDecoration: 'none' }}
                                        href={validateLinkedInUrl(contact?.socialLinks?.linkedin)}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {contact?.profileUrl &&
                                        !arrOfEmailsOfImageError.find((e) => e === contact?.email) ? (
                                            <img
                                                src={contact.profileUrl}
                                                alt={displayName(
                                                    contact.fullName,
                                                    contact.givenName,
                                                    contact.familyName,
                                                )}
                                            />
                                        ) : (
                                            <div className="roundedImgPlaceholder flex">
                                                {contact.givenName?.charAt(0).toUpperCase()}
                                            </div>
                                        )}
                                        {showLinkedin && validateLinkedInUrl(contact?.socialLinks?.linkedin) && (
                                            <div className="roundedSocial">
                                                <FontAwesomeIcon icon={faLinkedinIn} className="fa-xs" color="white" />
                                            </div>
                                        )}
                                    </a>
                                </div>
                                <h4 className="interviewerName">
                                    {displayName(contact.fullName, contact.givenName, contact.familyName)}
                                </h4>
                                <h5 className="interviewerTitle">{contact.title}</h5>
                            </div>
                        ),
                )}
            </div>
        </>
    );
};

export default MeetInterviewerSection;
